import React from "react";

import {
  ResponsiveContainer,
  BarChart,
  XAxis,
  YAxis,
  Tooltip,
  Bar,
  Cell,
} from "recharts";

import { Typography } from "clearsense-ui/components";
import ContentBox from "components/Common/ContentBox";

const RulesStatistics = ({ chartData }) => {
  const chartDetails = qaData => [
    {
      name: qaData.positive_string,
      value: qaData.positive,
      cellProps: { fill: "#00ba88" },
      label: "Compliant records",
      percent: `(${parseFloat(
        (qaData.positive / (qaData.positive + qaData.negative)) * 100
      ).toFixed(2)}%)`,
    },
    {
      name: qaData.negative_string,
      value: qaData.negative,
      cellProps: { fill: "#f56a58" },
      label: "Defiant Records",
      percent: `(${parseFloat(
        (qaData.negative / (qaData.positive + qaData.negative)) * 100
      ).toFixed(2)}%)`,
    },
  ];

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="p-1 border border-black border-solid bg-white bg-opacity-90">
          <p>{`${payload[0].payload.name} : ${payload[0].payload.value}`}</p>
        </div>
      );
    }

    return <div></div>;
  };

  return (
    <div className="flex flex-col w-full m-4 gap-4 pr-8">
      <ContentBox className="w-full">
        <Typography style="h4" type="semibold" className="mb-4">
          CDE Quality Analysis Rules Statistics
        </Typography>
        <div className="grid grid-cols-2 w-full gap-4">
          {chartData.map((qaData, idx) => (
            <ContentBox
              key={idx}
              showBorder={false}
              className="flex flex-col justify-center items-center bg-white"
            >
              <Typography style="h4" type="semibold">
                {qaData.title}
              </Typography>
              <div className="data_qa_dashboard__metrics_charts m-8">
                <ResponsiveContainer width="100%" height="100%">
                  <BarChart data={chartDetails(qaData)} barSize={80} barGap={0}>
                    <XAxis xAxisId="0" dataKey="label" />
                    <XAxis
                      xAxisId="1"
                      dataKey="percent"
                      axisLine={false}
                      tickLine={false}
                      tickMargin={0}
                      tickSize={0}
                    />
                    <YAxis />
                    <Tooltip
                      cursor={{ fill: "rgba(200, 200, 200, 0.1)" }}
                      payload={chartDetails(qaData)}
                      content={<CustomTooltip />}
                    />
                    <Bar dataKey="value">
                      {chartDetails(qaData).map((entry, index) => (
                        <Cell key={`cell-${index}`} {...entry.cellProps} />
                      ))}
                    </Bar>
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </ContentBox>
          ))}
        </div>
      </ContentBox>
    </div>
  );
};

export default RulesStatistics;
